import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ─── Service Worker registration with user-prompted update banner ──────────
// New SW versions trigger <UpdateBanner /> via a CustomEvent.
// User clicks "Atualizar agora" → SKIP_WAITING → controllerchange → reload.
//
// White-screen self-heal lives INLINE in /public/index.html so it can run
// even when the React bundle fails to load. Do NOT duplicate it here.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        updateViaCache: 'none',
      });

      registration.update().catch(() => {});

      const notifyUpdateAvailable = (worker) => {
        window.dispatchEvent(
          new CustomEvent('vital:update-available', { detail: { worker } })
        );
      };

      // A new SW was already waiting when the page loaded.
      if (registration.waiting && navigator.serviceWorker.controller) {
        notifyUpdateAvailable(registration.waiting);
      }

      // A new SW installs while the page is open.
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (
            newWorker.state === 'installed' &&
            navigator.serviceWorker.controller
          ) {
            notifyUpdateAvailable(newWorker);
          }
        });
      });

      // When the controlling SW changes (user clicked update), reload once.
      let reloaded = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (reloaded) return;
        reloaded = true;
        window.location.reload();
      });
    } catch (err) {
      // SW is enhancement, not requirement.
    }
  });
}
